module.exports = __webpack_public_path__ + "static/media/Technology Provider Network - GBR Tech - 01-04-2025 C.b142bd3c.gif";